<template>
    <span class="vfairbadge">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: 'Badge',
};
</script>

<style scoped>
.vfairbadge {
    font-size: 10px;
    font-weight: 600;
    border: 2px;
    border-style: solid;
    border-color: #000;
    border-radius: 4px;
    padding: 2px 8px 2px 8px;
    color: #000;
    text-transform: uppercase;
}
</style>
